// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1__3K","cls2":"ConfirmationModal-cls2_u7G ConfirmationModal-cls1__3K"};